module.exports = __webpack_public_path__ + "img/investor.9115ec84.png";